module.exports = __webpack_public_path__ + "img/2.eff6a707.png";